/**
 * Brand Consultant Types
 * 
 * TypeScript interfaces for the Brand Consultant feature components.
 * These types define the structure for messages, tool invocations, and session management.
 */

export interface Message {
  id: string;
  role: 'user' | 'assistant' | 'system' | 'tool';
  content: string;
  toolInvocations?: ToolInvocation[];
  timestamp: string;
  creditsUsed?: number;
}

export interface ToolInvocation {
  toolName: string;
  parameters: Record<string, any>;
  result: any;
  timestamp: string;
  status: 'pending' | 'success' | 'error';
}

export interface ConsultantSession {
  id: string;
  brand_id: string;
  account_id: string;
  session_name?: string;
  session_type: 'general' | 'brand_strategy' | 'content_planning' | 'market_analysis';
  status: 'active' | 'completed' | 'archived';
  metadata: Record<string, any>;
  created_at: string;
  updated_at: string;
  created_by?: string;
}

export interface ToolDefinition {
  type: 'function';
  function: {
    name: string;
    description: string;
    parameters: {
      type: 'object';
      properties: Record<string, any>;
      required?: string[];
    };
  };
}

export interface ChatResponse {
  response: string;
  toolInvocations?: ToolInvocation[];
  creditsUsed: number;
  sessionId: string;
}

export interface BrandConsultantError {
  error: string;
  details?: string;
  isProviderOutage?: boolean;
}

// Tool filtering configuration
export const HIDDEN_TOOLS = ['respond_to_user'] as const;

// Example message structure for component development reference:
/*
{
  id: "msg_123",
  role: "assistant",
  content: "I've analyzed your recent posts and found some interesting patterns...",
  toolInvocations: [
    {
      toolName: "get_recent_posts",
      parameters: { limit: 10, platform: "twitter" },
      result: { posts: [...], count: 10 },
      timestamp: "2025-01-17T10:30:00Z",
      status: "success"
    }
  ],
  timestamp: "2025-01-17T10:30:00Z",
  creditsUsed: 5
}
*/